'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PinchHandler = require('./components/PinchHandler.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PinchHandler).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-pan-zoom/lib/components/pinch-handler/index.js
// module id = 522
// module chunks = 1